"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _GojobLogo = _interopRequireDefault(require("../GojobLogo"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _TouchableOpacity = _interopRequireDefault(require("../TouchableOpacity"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing,
      breakpoint = _useTheme.breakpoint;

  return {
    root: (0, _defineProperty2["default"])({
      position: 'absolute',
      top: '50%',
      left: '50%',
      padding: spacing(1, 4),
      textDecoration: 'none',
      transform: "translate(-50%, -50%) translateY(".concat(spacing(-1), ")")
    }, breakpoint.up('lg'), {
      left: 0,
      transform: "translate(0%, -50%) translateY(".concat(spacing(-2), ")")
    }),
    logo: {
      margin: spacing(-1.5, 0)
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing, breakpoint }}", function () {
  return [_useTheme2["default"]];
});

var Logo = function Logo(props) {
  var classes = useStyles();
  return (0, _core.jsx)(_TouchableOpacity["default"], (0, _extends2["default"])({
    css: classes.root
  }, props), (0, _core.jsx)(_Icon["default"], {
    as: _GojobLogo["default"],
    css: classes.logo,
    color: "primary",
    size: 10
  }));
};

__signature__(Logo, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Logo;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Logo.tsx");
  reactHotLoader.register(Logo, "Logo", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Logo.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Logo.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();